/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-12 17:31:33
 * @modify date 2022-12-12 17:31:33
 * @desc display a list of social media accounts, this will add tooltips to the social media icon the user understands direction
 */

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import GMobiledataIcon from '@mui/icons-material/GMobiledata';

const SocialAccounts = () => {
    return (
        <div>
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center">
                <Tooltip title="Instagram: paigelouisewrites">
                    <IconButton href="https://www.instagram.com/paigelouisewrites/">
                        <InstagramIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Twitter: muff_in">
                    <IconButton href="https://twitter.com/muff_inn">
                        <TwitterIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Spotify: Hypothetical Happy (Half) Hour">
                    <IconButton href="https://open.spotify.com/show/30oxaeAfUbJnSsLFSxgP9T">
                        <PodcastsIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Goodreads: Paige Hart">
                    <IconButton href="https://www.goodreads.com/author/show/18981037.Paige_Hart">
                        <GMobiledataIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Instagram: read.by.paige">
                    <IconButton href="https://www.instagram.com/read.by.paige/">
                        <InstagramIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        </div>
    )
}

export default SocialAccounts;